"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
const useLockButtonText_1 = require("./hooks/useLockButtonText");
exports.EmailCanvasBlockLockButton = ({ lockable, locked, updateBlock, canLock, adminRole, showOverlay, showOnOverlay = false, parentIsLocked, }) => {
    if (!lockable) {
        return null;
    }
    const disabled = (showOverlay && !showOnOverlay) ||
        !canLock ||
        (!showOnOverlay && (locked || parentIsLocked));
    const [text, tooltip] = useLockButtonText_1.useLockButtonText(adminRole, showOnOverlay, locked, disabled, parentIsLocked);
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, { noMargin: showOnOverlay },
        react_1.default.createElement(react_2.OsmosysButton, { osysName: "EmailCanvasBlockLockButton", blurOnClick: true, disabled: disabled, osysStyle: showOnOverlay ? 'blockOverlay' : 'blockToolbarDanger', onClick: () => {
                if (disabled) {
                    return;
                }
                updateBlock({
                    locked: !locked,
                });
            }, tooltip: tooltip, osysIcon: adminRole === 'app' ? 'appAdminsOnly' : 'workspaceAdminsOnly' }, text)));
};
//# sourceMappingURL=LockButton.js.map